module.exports = "https://la-static.vkplay.ru/promo/newstart/img/sorceress.e27bf005.png";